import React from 'react'

import { connect } from 'react-redux';
import * as actionCreators from '../../actions/user';
import PropTypes from "prop-types";
import { bindActionCreators } from 'redux';
import Button from '@material-ui/core/Button';
import './styles.scss';

import NumberFormat from 'react-number-format';
import Checkbox from '@material-ui/core/Checkbox';
import Resizer from 'react-image-file-resizer';
import SearchIcon from '@material-ui/icons/Search'
import TextField from '@material-ui/core/TextField';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import Notification from '../Notifications'
import NewWindow from 'react-new-window'

import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Switch from '@material-ui/core/Switch';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ProductApi } from '../../api/product_api';
import { ProductMetrics } from './ProductMetrics'
import { ADMIN_ROLE } from '../../constants'
import CreateIcon from '@material-ui/icons/Create';
import Modal from '@material-ui/core/Modal';
import Paper from '@material-ui/core/Paper';
import { DropzoneArea } from 'material-ui-dropzone'
import MemoryIcon from '@material-ui/icons/Memory';
var QRCode = require('qrcode.react');
import CropFreeIcon from '@material-ui/icons/CropFree';

function mapStateToProps(state) {
    return {
        userRoles: state.user.userRoles

    };
}

function mapDispatchToProps(dispatch) {
    return {}
}

const NO_PROD = "data:image/png;base64,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"



const customStyles = {
    top: `10%`,
    margin: 'auto',
    width: 300,
    height: 400,
    background: 'rgba(r, g, b, a)',
    content: {
        top: '30%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};


function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;
    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        value: values.value,
                    },
                });
            }}
            decimalScale={2}
            thousandSeparator={'.'}
            decimalSeparator={','}
            prefix="$"
        />
    );
}


@connect(mapStateToProps, mapDispatchToProps)
export class SingleProductView extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            open: false,
            codeProd: '',
            loaded: false,
            product: null,
            details: false,
            metricData: null,
            editProduct: false,
            generateQr: false,
            tempStock: null,
            tempImage: null,
            tempPrice: null,
            files: [],
            openPrintQr: false,
            printQr: false,
            qrAmount: 0,
            msg: null,
            msgType: null,
            showMsg: false,
            tempBrand: null,
            tempModel: null,

        }
    }

   
    updateProduct = (e) =>{
        const newProductData = {'id': this.state.product.id, 'image': this.state.tempImage,
                                'stock': parseInt(this.state.tempStock || 0),
                                'price': parseFloat(this.state.tempPrice),
                                'brand': this.state.tempBrand,
                                'model': this.state.tempModel}
        ProductApi.updateProduct(this.state.product.id, newProductData)
        .then(response =>{
            let prod = this.state.product
            prod.price = this.state.tempPrice
            prod.stock = this.state.tempStock
            prod.image = this.state.tempImage
            prod.brand = this.state.tempBrand
            prod.model = this.state.tempModel
            this.setState({product:prod, editProduct: false})
        })
        .catch(error=>{
            this.setState({msg:error.response.data.message, showMsg: true, msgType: 'error',editProduct: false})
        })
    }
    onSearch = e => {
        this.setState({ open: true });
    }
    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        this.setState({ open: false });
    }
    handleFileChange = (files)=> {
        if (files.length > 0) {
            Resizer.imageFileResizer(files[0], 500, 500, 'JPEG', 100, 0, uri => {
                this.setState({ tempImage: uri })
            },
                'base64'
            );
        };
        this.setState({
            files: files
        });
    }
    searchProduct = e => {
        if (e.keyCode == 13) {

            ProductApi.get(this.state.codeProd)
                .then((response) => {
                    let prod = response.data.product
                    if(prod === undefined){
                        prod = response.data.combo
                        prod.product_type = 'Combo'
                    }
                    if (prod.image == null) {
                        prod.image = NO_PROD
                    }
                    this.setState({ loaded: true, product: prod, tempImage: prod.image, tempPrice: prod.price, tempStock: prod.stock,
                                    tempBrand: prod.brand, tempModel: prod.model});
                }
                )
                .catch(error => {
                    this.setState({ open: true, details: false });
                })
            if (this.state.details) {
                this.fetchMetrics()
            }
            this.setState({ loaded: false, metricData: null });
        }
        else if (!isNaN(e.key)) {
            this.setState({ codeProd: this.state.codeProd + e.key })
        }
        else if (e.keyCode == 8) {
            const prod = this.state.codeProd.slice(0, this.state.codeProd.length - 1)
            this.setState({ codeProd: prod })
        }

    }
    getAttributes = () => {
        let attrs = []
        Object.entries(this.state.product.attributes).map(([name, value]) => {
            if (typeof value === 'boolean') {
                value = value ? 'si' : 'no'
            }
            let newAttr = <Typography key={attrs.length} id={attrs.length} variant="subtitle1" gutterBottom>
                <b>{name}: </b> {value}
            </Typography>

            attrs.push(newAttr)
        })
        return attrs
    }

    showMetrics = (e) => {
        if (!this.state.details) {
            this.fetchMetrics()
            this.setState({ metricData: null })
        }
        this.setState({ details: !this.state.details })

    }

    fetchMetrics = () => {
        ProductApi.getMetrics(this.state.codeProd)
            .then(response => {
                this.setState({ metricData: response.data })
            })
            .catch(error => {
                console.error(error)
            })
    }
    activateProduct = (e) => {
        let prodDetails = this.state.product;
        prodDetails.active = e.target.checked
        this.setState({ product: prodDetails })
        ProductApi.updateProduct(prodDetails.id, { 'id': prodDetails.id, 'active': e.target.checked })
    }

    getQrs = () =>{
        let qrs = []
            
        if(this.state.openPrintQr){
        
            for(let i=0; i < this.state.qrAmount; i++ ){
                qrs.push(<div style={{marginLeft:25,  marginRight:15, marginTop:1}}>
                    <Typography style={{marginLeft: 5, marginTop:-20}} variant="caption">
                                {this.state.product.id.toString()}
                            </Typography>
                    <div class="grid-child green" >
                    
                            <QRCode
                                size={38}
                                quality={1}
                                errorCorrectionLevel={'high'}
                                renderAs={'svg'}
                                version={40}
                                level={"H"}
                                value={this.state.product.id.toString()}
                                >
                            </QRCode>
                            
                        </div>
                        </div>  )
            }
        
        }
        return qrs
    }
    donePrinting = () =>{
        this.setState({ openPrintQr: false, prodId: null })
    }
    render() {
        const isAdmin = this.props.userRoles.includes(ADMIN_ROLE)
        console.log(isAdmin)
        let attributes = null
        if (this.state.product && this.state.product.attributes) {
            attributes = this.getAttributes()
        }
        return (
            <div>


                <div className="col-md-12" style={{ marginTop: 20 }}>

                    {/* <IconButton onClick={(e)=>{this.setState({editProduct: !this.sate.editProduct})}} aria-label="Search"> */}
                    <IconButton aria-label="Search">
                        <SearchIcon />
                    </IconButton>
                   
                    <InputBase
                        autoFocus
                        placeholder="12345"
                        value={this.state.codeProd}
                        onKeyDown={this.searchProduct} />
                    <Notification
                        open={this.state.open}
                        variant="error"
                        message="El Producto no existe"
                        onClose={this.handleClose}
                    />
                    <Divider />
                    {this.state.loaded &&
                        <div className='col-md-12' style={{ marginTop: 10 }}>
                            <div className='col-md-9' style={{ marginTop: 20 }}>
                                <Typography variant="subtitle1" gutterBottom>
                                    <b>Tipo de Producto: </b> {this.state.product.product_type}
                                </Typography>
                                <Typography variant="subtitle1" gutterBottom>
                                    <b>Marca: </b> {this.state.product.brand}
                                </Typography>
                                <Typography variant="subtitle1" gutterBottom>
                                    <b>Modelo: </b> {this.state.product.model}
                                </Typography>
                                <div style={{ marginTop: 10 }}>
                                    {attributes}
                                </div>
                            </div>
                            <div className='col-md-3' >
                                <div className='col-md-12 col-md-offset-9'>
                                    {isAdmin &&
                                        <IconButton onClick={(e) =>{this.setState({editProduct: !this.state.editProduct})}} aria-label="Search">
                                            <CreateIcon />
                                        </IconButton>
                                        }
                                        
                                        <IconButton onClick={(e) =>{this.setState({generateQr: !this.state.generateQr})}} aria-label="Search">
                                            <MemoryIcon />
                                    
                                        </IconButton>
                                </div>
                              
                                <img src={this.state.product.image}
                                    style={{ width: 150, height: 150, marginLeft: 35 }} />

                                <Typography variant="h6" gutterBottom align='center'>
                                    <b>Stock: </b> {this.state.product.stock}
                                </Typography>

                                <Typography variant="h6" gutterBottom align='center' >
                                    <b>Precio: </b> <NumberFormat
                                        value={this.state.product.price}
                                        displayType={'text'}
                                        thousandSeparator={'.'}
                                        decimalSeparator={','}
                                        prefix="$"
                                    />
                                </Typography>
                            </div>

                            
                        </div>}

                    {(this.props.userRoles.includes(ADMIN_ROLE) && this.state.product) ?
                        <div>
                            <div className='col-md-10' style={{ marginTop: 10 }}>
                                <FormGroup row>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={this.state.details}
                                                onChange={this.showMetrics}
                                                color="primary"

                                            />
                                        }
                                        label='Detalles'
                                    />
                                </FormGroup>
                            </div>
                            <div className='col-md-2' style={{ marginTop: 10 }}>
                                <FormGroup row>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={this.state.product.active}
                                                onChange={this.activateProduct}
                                                value=""
                                            />
                                        }
                                        label="Activado"
                                    />
                                </FormGroup>
                            </div>
                        </div> : <div></div>}
                    {this.state.details && this.state.metricData == null ?
                        <div style={{ marginTop: 120 }} className="col-md-6 col-md-offset-5">
                            <CircularProgress
                                size={100}
                                color='primary'
                                thickness={3}
                                style={{ display: 'center' }} />
                        </div> : <div></div>
                    }
                    {this.state.details && this.state.metricData != null ?
                        // <div style={{ height: 700, marginTop: 320 }}>
                        <div>
                            <ProductMetrics
                                style={{ marginTop: 300 }}
                                metrics={this.state.metricData}
                                id={this.state.product.id}
                                productType={this.state.product.product_type} />
                        </div> : <div></div>


                    }

                    <Modal
                        style={customStyles}
                        open={this.state.editProduct}
                        onClose={(e) =>{this.setState({editProduct: !this.state.editProduct})}}
                    >
                        <Paper elevation={4}>
                            <div style={{ marginTop: 30 }}>
                                <div style={{ marginLeft: 10, marginTop: 30 }}>
                                    <Typography variant="h6" gutterBottom>
                                        {this.state.product != null && this.state.product.product_type + ' ' + 
                                         this.state.product.brand + ' ' + this.state.product.model}
                                    </Typography>
                                </div>
                                <Divider />
                                <div style={{ marginTop: 40  }}>
                                
                                <DropzoneArea
                                    files
                                    onChange={this.handleFileChange.bind(this)}
                                    acceptedFiles={['image/jpeg', 'image/png', 'image/jpg']}
                                    maxFileSize={500000}
                                    showPreviewsInDropzone={true}
                                    filesLimit={1}
                                    dropzoneText={""}
                                    dropZoneClass="MyDropZone" />
                                </div>
                                <div style={{ marginLeft: 20, marginTop: 20 }}>
                                <TextField
                                    label="Stock"
                                    onChange={(e)=>{
                                            this.setState({tempStock: e.target.value})

                                    }}
                                    style={{ marginLeft: 15 }}
                                    type="number"
                                    value={this.state.tempStock}

                                />
                                </div>
                                <div style={{ marginLeft: 20, marginTop: 20 }}>
                                <TextField
                                    label="Precio"
                                    onChange={(e)=>{
                                            this.setState({tempPrice: e.target.value})

                                    }}
                                    InputProps={{
                                        inputComponent: NumberFormatCustom,
                                    }}
                                
                                    
                                    style={{ marginLeft: 15 }}
                                    type="text"
                                    value={this.state.tempPrice}

                                />
                                 <TextField
                                    label="Marca"
                                    onChange={(e)=>{
                                            this.setState({tempBrand: e.target.value})

                                    }}
                                    style={{ marginLeft: 15 }}
                                    type="text"
                                    value={this.state.tempBrand}

                                />
                                 <TextField
                                    label="Modelo"
                                    onChange={(e)=>{
                                            this.setState({tempModel: e.target.value})

                                    }}
                                    style={{ marginLeft: 15 }}
                                    type="text"
                                    value={this.state.tempModel}

                                />
                                </div>
                                <br></br>
                                <div style={{ marginLeft: 80, marginTop: 20, marginBoton:20}}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={(e) => this.updateProduct(e)}
                                >
                                    Actualizar
                                </Button>
                                <br></br>
                                </div>
                            </div>
                        </Paper>
                    </Modal>
                    <Modal
                        style={customStyles}
                        open={this.state.generateQr}
                        onClose={(e) =>{this.setState({generateQr: !this.state.generateQr})}}
                    >
                        <Paper elevation={4}>
                            <div style={{ marginTop: 30 }}>
                                <div style={{ marginLeft: 10, marginTop: 30 }}>
                                    <Typography variant="h6" gutterBottom>
                                        {this.state.product != null && this.state.product.product_type + ' ' + 
                                         this.state.product.brand + ' ' + this.state.product.model}
                                    </Typography>
                                </div>
                                <Divider />
                                <div style={{ marginTop: 40  }}>
                               
                                <div style={{ marginLeft: 20, marginTop: 20 }}>
                                <TextField
                                    label="cantidad"
                                    onChange={(e)=>{
                                            this.setState({qrAmount: e.target.value})

                                    }}
                                    style={{ marginLeft: 15 }}
                                    type="number"
                                    value={this.state.qrAmount}

                                />
                                </div>
                               
                                <div style={{ marginLeft: 80, marginTop: 20, marginBoton:20}}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={(e) => this.setState({openPrintQr: true})}
                                >
                                    Generar QRs
                                </Button>
                                <br></br>
                                </div>
                            </div>
                            </div>
                        </Paper>
                    </Modal>
                    {this.state.openPrintQr &&
                    <NewWindow onUnload={this.donePrinting}>
                        <div class="grid-container">
                        {this.getQrs()}
                        </div>
                        </NewWindow>
                    }

                </div>
                <Notification
                        open={this.state.showMsg}
                        variant={this.state.msgType}
                        message={this.state.msg}
                        onClose={this.handleClose}
                    />
            </div>
        )
    }

}





// WEBPACK FOOTER //
// ./src/components/Products/Product.js